'use client';

import { c as _c } from "react/compiler-runtime";
import { FullscreenExitIcon, FullscreenIcon } from '@/app/[locale]/(worlds)/[roomId]/components/FullscreenIcons';
import { useFullscreenStatus } from '@/hooks/useFullscreenStatus';
import { toggleFullscreen } from '@/lib/fullscreen';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
export default function EmbedFullscreenButton() {
  const $ = _c(10);
  const t = useTranslations();
  const {
    isFullscreen
  } = useFullscreenStatus();
  const Icon = isFullscreen ? FullscreenExitIcon : FullscreenIcon;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0
    };
    t1 = {
      opacity: 1
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      duration: 0.6,
      ease: [0.4, 0, 0.2, 1]
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("enter-fullscreen-modal.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== Icon) {
    t4 = <Icon className="size-6 shrink-0 transition-[opacity,fill] duration-200 group-hover:opacity-90 [&_path]:fill-[#D5E2F2] group-hover:[&_path]:fill-vive-brand-50" />;
    $[5] = Icon;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <motion.div initial={t0} animate={t1} transition={t2} className="absolute right-5 bottom-4 z-floating"><button type="button" aria-label={t3} className="group flex cursor-pointer items-center justify-center gap-4 rounded-3xl bg-black/40 px-4 py-2 backdrop-blur-sm transition-colors duration-200 hover:bg-black/55" onClick={_temp}>{t4}</button></motion.div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp() {
  toggleFullscreen("standalone-iframe-wrapper");
}